<h1>Tag Name Codebooks</h1>
<p>
  Page to manage tag name codebooks. They will be automatically downloaded by sites and used for validation of new tags.
</p>
<button mat-raised-button color="primary" (click)="openCreateDialog()">Add new codebook</button>
<br /><br />

<div *ngIf="!isLoading; else loading">
  <table mat-table [dataSource]="codebooks" matSort class="mat-elevation-z8" style="width: 100%">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.codebook?.name || element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="revision">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Revision</th>
      <td mat-cell *matCellDef="let element">{{ element.codebook?.revision }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let element">{{ element.codebook?.description }}</td>
    </ng-container>

    <ng-container matColumnDef="namingLevels">
      <th mat-header-cell *matHeaderCellDef>Naming Levels</th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="getNamingLevelsSummary(element)">
          {{ element.codebook?.namingLevels?.length || 0 }} levels
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastUpdatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
      <td mat-cell *matCellDef="let element">{{ formatDate(element.lastUpdatedAt) }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button (click)="openEditDialog(element)" style="margin-right: 8px">Edit</button>
        <button mat-raised-button color="warn" (click)="deleteCodebook(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<ng-template #loading>
  <div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
</ng-template>
